// extracted by mini-css-extract-plugin
export var childrenButton = "itemTooltip-module--childrenButton--4kfNJ";
export var childrenButtonAbPkw = "itemTooltip-module--childrenButtonAbPkw--vXHIP";
export var childrenContainer = "itemTooltip-module--childrenContainer--cUhqr";
export var childrenImg = "itemTooltip-module--childrenImg--Yf-r8";
export var childrenText = "itemTooltip-module--childrenText--CJ5pE";
export var childrenTextAbPkw = "itemTooltip-module--childrenTextAbPkw--SvQHZ";
export var close = "itemTooltip-module--close--NHOHL";
export var hintContainer = "itemTooltip-module--hintContainer--tH1ti";
export var hintIcon = "itemTooltip-module--hintIcon--cXyNK";
export var hintModal = "itemTooltip-module--hintModal--i-U+1";
export var hintModalAB = "itemTooltip-module--hintModalAB--MNLAB";
export var newYearMedia = "itemTooltip-module--newYearMedia--K5mGp";
export var wrapperChildren = "itemTooltip-module--wrapperChildren--aXaGy";